import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import { Flex } from 'reflexbox'
import { Button } from 'react-toolbox/lib/button'
import { Link } from 'react-router-dom'
import { mapProps, branch, compose, renderComponent } from 'recompose'

import withAsync from 'containers/Async/index'
import withRedirectLink from 'components/fulcrum/link/FulcrumReactRouterLink'
import ProgressBar from 'components/fulcrum/progressBar/FulcrumCircularProgressBar'

import {
  POST_UPDATE_PROJECT,
  POST_WORKFLOW_SUBMIT,
  FORM_STATUS,
} from 'containers/Project/constants'
import styles from './styles.scss'

const Progress = () => <ProgressBar theme={styles}/>

const withProgressBar = branch(
  ({ loading }) => loading,
  renderComponent(Progress)
)

const buttonHoc = compose(
  withAsync,
  withProgressBar,
  withRedirectLink,
  mapProps(({ dispatch, loading, ...rest }) => ({...rest}))
)(Button)

const NextButton = buttonHoc([
  POST_UPDATE_PROJECT,
  POST_WORKFLOW_SUBMIT
])

const ActionBar = (props) => {
  const { id, setFormStatus, onSubmit, styles, ...rest } = props
  return (
    <Flex flex justify='flex-end' styleName='actionBar'>
      <Link styleName='backLink' to={`/project/${id}/update`}>
        <Button
          onClick={() => setFormStatus(FORM_STATUS.UPDATE)}
          label='Back'
          primary
          raised
          ripple
        />
      </Link>
      <NextButton
        {...rest}
        to={'/project/search'}
        onClick={onSubmit}
        label='Save'
        primary
        raised
        ripple
      />
    </Flex>
  )
}

export default CSSModules(ActionBar, styles)
